import { z } from 'zod'

// Organization schema for form validation and data handling
export const organizationSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Organization name is required'),
  logo: z.string().optional(),
  isEnterprise: z.boolean().default(false),
  createdBy: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

// Create organization form schema (without id and timestamps)
export const createOrganizationSchema = organizationSchema.omit({
  id: true,
  createdBy: true,
  createdAt: true,
  updatedAt: true,
})

// Update organization form schema (excludes id, createdBy and timestamps)
export const updateOrganizationSchema = organizationSchema.omit({
  id: true,
  createdBy: true,
  createdAt: true,
  updatedAt: true,
})

export type Organization = z.infer<typeof organizationSchema>
export type CreateOrganizationInput = z.infer<typeof createOrganizationSchema>
export type UpdateOrganizationInput = z.infer<typeof updateOrganizationSchema>

export const organizationListSchema = z.array(organizationSchema)
